import { RESET_CREATIVES } from './actionTypes';

export default () => ({
    type: RESET_CREATIVES,
});
